<template>
  <div class="colorful-background wrapper-grid">
    <div :class="['img', { animate__animated: isFirst }, 'animate__fadeIn']">
      <image-box side-position="right" img-u-r-l="/pic/5.png"></image-box>
    </div>

    <div
      :class="[
        'title',
        { animate__animated: isFirst },
        'animate__flipInX',
        'small-margin-top',
      ]"
    >
      <span class="small-font">本学期的第一节课是</span>
      <span class="middle-font too-long-text" style="text-align: left;">
        {{ schedule_first_class.COURSE }}
      </span>
    </div>

    <div
      :class="[
        'text',
        { animate__animated: isFirst },
        'animate__fadeIn',
        'middle-margin-top',
      ]"
      style="align-items: flex-end;"
    >
      <span class="small-font">在上午{{ schedule_first_class.STARTTIME }}</span>
      <span class="small-font">您开启了本学期的旅程</span>
      <span class="small-font">这将是一段收获满满的旅程</span>
    </div>

    <div
      :class="[
        'slogan',
        { animate__animated: isFirst },
        ' animate__fadeIn',
        ' big-margin-top',
      ]"
    >
      <span class="small-font">这一学期收获了什么呢？</span>
      <span class="small-font small-margin-top">跟小助手分享一下吧</span>
    </div>

    <div class="footer middle-margin-bottom">
      <div class="very-small-font">
        课程数据由杭电教务处提供,分析数据均在理想情况下计算
      </div>
      <span class="very-small-font">数据仅供参考</span>
    </div>
  </div>
</template>

<script>
import store from '@/store/store'
import ImageBox from '@/components/utils/imageBox'
export default {
  name: 'firstClassPage',
  components: {
    ImageBox,
  },
  props: {
    isFirst: { type: Boolean, default: true },
  },
  computed: {
    schedule_first_class: function () {
      return store.state.$data.data.Schedule.FirstClass.Schedule
    },
  },
}
</script>

<style scoped>
.img.animate__animated {
  animation-delay: var(--first-delay);
  animation-duration: var(--defalut-continue);
}

.title.animate__animated {
  animation-delay: var(--second-delay);
}

.text.animate__animated {
  animation-delay: var(--third-delay);
  animation-duration: var(--defalut-continue);
}

.slogan.animate__animated {
  animation-delay: var(--fourth-delay);
  animation-duration: var(--defalut-continue);
}

.colorful-background.wrapper-grid {
  --angle: 45deg;
  --first-color: var(--quyuan-red);
  --page-background-color: var(--rose-gold);
  --second-color: var(--light-orange);
}
</style>
